import {CURRENCY, formatDate, API_URL } from "@constants/index";
import InputCustom from "@pages/components/InputCustom";
import { InputArraySelect, InputKeySelect } from "@pages/components/InputSelect";
import VerticalLabel from "@pages/components/VerticalLabel";
import { ButtonContainer } from "@pages/reusable-components/styled-components";
import axios from 'axios';
import Cookies from 'js-cookie';
import React, {useEffect, useState} from "react";
import {Card, CardBody, CardHeader, Col, Input, Row, Table} from "reactstrap";

interface VehicleDetailsProps {
    initialVehicle: any;
    settlementCostInitial: any;
    fundingStyles: any;
    soldErrors: any;
    errors: any;
    delay: any;
    vehicleRepository: any;
    getValuation: () => void;
    updateVehicleAdministrative: (vehicle?: any, settlementCost?: any, callback?: () => void) => void;
    financialDetails: () => void;
    sold: (data: any) => void;
}
const VehicleFinancial: React.FC<VehicleDetailsProps> = ({initialVehicle,getValuation,
                                                             soldErrors,errors,delay,
                                                             vehicleRepository,
                                                             sold,
                                                             updateVehicleAdministrative,settlementCostInitial,
                                                             financialDetails,fundingStyles}) => {

    const [vehicle, setVehicle] = useState<any>(initialVehicle);
    const [settlementCost, setSettlementCost] = useState<any>(initialVehicle);
    const [funders, setFunders] = useState<any[]>([]);

    const [updateValuationEnable, setUpdateValuationEnable] = useState<boolean>(true)

    useEffect(()=>{
        if (initialVehicle && Object.keys(initialVehicle).length) {
            setVehicle(initialVehicle);
        }
    },[initialVehicle])
    useEffect(() => {
        if (settlementCostInitial && Object.keys(settlementCostInitial).length) {
            setSettlementCost(settlementCostInitial);
        }
    }, [settlementCostInitial])

    useEffect(() => {
        const token = Cookies.get('grs_token');
        axios.get(`${API_URL}/supplying-dealer`, {
            headers: { Authorization: `Bearer ${token}` },
        }).then(response => {
            setFunders(response.data.data);
        }).catch(error => {
            console.error('Failed to fetch funders :: ', error);
        });
    }, [])

    const setAdministrativeValues = (e, key) => {
        const target = e.target.value;
        setVehicle(prevVehicle => ({
            ...prevVehicle,
            administrative: {
                ...prevVehicle.administrative,
                [key]: target,
            },
        }));
    }

    return (
        <CardBody>
            <Card>
                <CardBody>
                    <Row>
                        <Col md={9} sm={12}>
                        </Col>
                        <Col md={3} sm={12}>
                            <ButtonContainer onClick={() => getValuation()}>Get Valuation</ButtonContainer>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <h2>{`Valuations ${vehicle && vehicle.administrative?.valuation_time ? `(${formatDate(vehicle.administrative.valuation_time)})` : ''}`}</h2>
                        </Col>
                        <Col md={3} sm={12}>
                            <VerticalLabel label={`Dealer Forecourt`} value={vehicle && vehicle.administrative?.dealer_forecourt ? `${CURRENCY} ${vehicle.administrative.dealer_forecourt}` : ` `} />
                        </Col>
                        <Col md={3} sm={12}>
                            <VerticalLabel label={`Part Exchange`} value={vehicle && vehicle.administrative?.part_exchange ? `${CURRENCY} ${vehicle.administrative.part_exchange}` : ` `} />
                        </Col>
                        <Col md={3} sm={12}>
                            <VerticalLabel label={`Trade Poor`} value={vehicle && vehicle.administrative?.trade_poor ? `${CURRENCY} ${vehicle.administrative.trade_poor}` : ` `} />
                        </Col>
                        <Col md={3} sm={12}>
                            <VerticalLabel label={`Trade Retail`} value={vehicle && vehicle.administrative?.trade_retail ? `${CURRENCY} ${vehicle.administrative.trade_retail}` : ` `} />
                        </Col>
                        <Col md={3} sm={12}>
                            <VerticalLabel label={`Trade Average`} value={vehicle && vehicle.administrative?.trade_average ? `${CURRENCY} ${vehicle.administrative.trade_average}` : ` `} />
                        </Col>
                        <Col md={3} sm={12}>
                            <VerticalLabel label={`Auction`} value={vehicle && vehicle.administrative?.auction ? `${CURRENCY} ${vehicle.administrative.auction}` : ` `} />
                        </Col>
                        <Col md={3} sm={12}>
                            <VerticalLabel label={`Settlement figure`} value={settlementCost?.settlementCost !== null && settlementCost?.settlementCost !== undefined ? `${CURRENCY} ${settlementCost.settlementCost}` : ` `} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className={'mb-3'}>
                            <ButtonContainer reverse
                                             onClick={() => {
                                                 setUpdateValuationEnable(false);
                                                 updateVehicleAdministrative(vehicle, settlementCost, () => {
                                                     setUpdateValuationEnable(true);
                                                 })
                                             }} disabled={!updateValuationEnable}>Save</ButtonContainer>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={9} sm={12}>
                            <h2 className="title mb-0">Financial information</h2>
                        </Col>
                        <Col md={12} className={'mb-3'}>
                            <ButtonContainer onClick={() => financialDetails()}>Financial details</ButtonContainer>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} sm={12}>
                            <InputCustom
                                type={`date`}
                                newLabel={`First Finance Payment`}
                                value={vehicle && vehicle.administrative?.delivered_to_us ? formatDate(vehicle.administrative.delivered_to_us) : ''}
                                onChange={e => setVehicle({
                                    ...vehicle,
                                    administrative: {
                                        ...vehicle.administrative,
                                        delivered_to_us: e.target.value,
                                    }
                                })}
                                invalid={soldErrors && soldErrors.delivered_to_us ? true : false}
                                errorMessage={soldErrors.delivered_to_us}
                            />
                            <InputArraySelect
                                newLabel={`Funding styles`}
                                value={vehicle && vehicle.administrative?.funding_style_id ? vehicle.administrative.funding_style_id : ''}
                                options={fundingStyles}
                                onChange={e => setAdministrativeValues(e, 'funding_style_id')}
                                valueKey={`id`}
                                labelKey={`name`}
                                defaultOption={true}
                                invalid={errors && errors.funding_style_id ? true : false}
                                errorMessage={errors.funding_style_id}
                            />
                            <InputCustom
                                type={`number`}
                                newLabel={`Purchase Price`}
                                value={vehicle && vehicle.administrative?.otr ? vehicle.administrative.otr : ''}
                                onChange={e => setAdministrativeValues(e, 'otr')}
                                invalid={soldErrors && soldErrors.administrative.otr ? true : false}
                                errorMessage={soldErrors.otr}
                            />
                            <InputCustom
                                type={`number`}
                                newLabel={`Total`}
                                value={vehicle && vehicle.administrative?.total ? vehicle.administrative.total : ''}
                                onChange={e => setAdministrativeValues(e, 'total')}
                                invalid={soldErrors && soldErrors.total ? true : false}
                                errorMessage={soldErrors.total}
                            />
                            <InputCustom
                                type={`number`}
                                newLabel={`Balance financed`}
                                value={vehicle && vehicle.administrative?.balance_financed ? vehicle.administrative.balance_financed : ''}
                                onChange={e => setAdministrativeValues(e, 'balance_financed')}
                                invalid={soldErrors && soldErrors.balance_financed ? true : false}
                                errorMessage={soldErrors.balance_financed}
                            />
                            <InputCustom
                                type={`number`}
                                newLabel={`Term`}
                                value={vehicle && vehicle.administrative?.term ? vehicle.administrative.term : ''}
                                onChange={e => setAdministrativeValues(e, 'term')}
                                invalid={soldErrors && soldErrors.term ? true : false}
                                errorMessage={soldErrors.term}
                            />
                            <InputCustom
                                type={`text`}
                                newLabel={`Profile`}
                                value={vehicle && vehicle.administrative?.profile ? vehicle.administrative.profile : ''}
                                onChange={e => setAdministrativeValues(e, 'profile')}
                                invalid={soldErrors && soldErrors.profile ? true : false}
                                errorMessage={soldErrors.profile}
                            />
                            <InputCustom
                                type={`number`}
                                newLabel={`Option to purchase`}
                                value={vehicle && vehicle.administrative?.end_payment ? vehicle.administrative.end_payment : ''}
                                onChange={e => setAdministrativeValues(e, 'end_payment')}
                                invalid={soldErrors && soldErrors.end_payment ? true : false}
                                errorMessage={soldErrors.end_payment}
                            />
                            <InputCustom
                                type={`date`}
                                newLabel={`Breakdown Expiry Date`}
                                value={vehicle && vehicle.administrative?.breakdown_expiry_date ? formatDate(vehicle.administrative.breakdown_expiry_date) : ''}
                                onChange={e => setVehicle({
                                    ...vehicle,
                                    administrative: {
                                        ...vehicle.administrative,
                                        breakdown_expiry_date: e.target.value,
                                    }
                                })}
                                invalid={soldErrors && soldErrors.breakdown_expiry_date ? true : false}
                                errorMessage={soldErrors.breakdown_expiry_date}
                            />
                        </Col>
                        <Col md={6} sm={12}>
                            <InputCustom
                                type={`date`}
                                newLabel={`Finance End Date`}
                                value={vehicle && vehicle.administrative?.end_date ? formatDate(vehicle.administrative.end_date) : ''}
                                onChange={e => setAdministrativeValues(e, 'end_date')}
                                invalid={soldErrors && soldErrors.end_date ? true : false}
                                errorMessage={soldErrors.end_date}
                            />
                            <InputCustom
                                newLabel={`Agreement number`}
                                value={vehicle && vehicle.administrative?.agreement_number ? vehicle.administrative.agreement_number : ''}
                                onChange={e => setAdministrativeValues(e, 'agreement_number')}
                                invalid={soldErrors && soldErrors.agreement_number ? true : false}
                                errorMessage={soldErrors.agreement_number}
                            />
                            <InputArraySelect
                                newLabel={`Funder`}
                                value={vehicle && vehicle.administrative?.supplying_dealer_id ? vehicle.administrative.supplying_dealer_id : ''}
                                options={funders}
                                onChange={e => setAdministrativeValues(e, 'supplying_dealer_id')}
                                valueKey={`id`}
                                labelKey={`name`}
                                defaultOption={true}
                                invalid={soldErrors && soldErrors.supplying_dealer_id ? true : false}
                                errorMessage={soldErrors.supplying_dealer_id}
                            />
                            <InputCustom
                                type={`number`}
                                newLabel={`VAT`}
                                value={vehicle && vehicle.administrative?.total_deposit ? vehicle.administrative.total_deposit : ''}
                                onChange={e => setAdministrativeValues(e, 'total_deposit')}
                                invalid={soldErrors && soldErrors.total_deposit ? true : false}
                                errorMessage={soldErrors.total_deposit}
                            />
                            <InputCustom
                                type={`number`}
                                newLabel={`Deposit`}
                                value={vehicle && vehicle.administrative?.non_refundable_deposit ? vehicle.administrative.non_refundable_deposit : ''}
                                onChange={e => setAdministrativeValues(e, 'non_refundable_deposit')}
                                invalid={soldErrors && soldErrors.non_refundable_deposit ? true : false}
                                errorMessage={soldErrors.non_refundable_deposit}
                            />
                            <InputCustom
                                type={`number`}
                                required
                                checkValid={false}
                                newLabel={`Monthly Cost`}
                                value={vehicle && vehicle.administrative?.monthly_cost ? vehicle.administrative.monthly_cost : ''}
                                onChange={e => setAdministrativeValues(e, 'monthly_cost')}
                                invalid={soldErrors && soldErrors.monthly_cost ? true : false}
                                errorMessage={soldErrors.monthly_cost}
                            />

                            <InputKeySelect
                                newLabel={`VAT Deferral`}
                                value={vehicle && vehicle.administrative?.vat_deferral ? vehicle.administrative.vat_deferral : ''}
                                options={{
                                    false: 'No',
                                    true: 'Yes',
                                }}
                                onChange={e => {
                                    const target = e.target.value;
                                    setVehicle(prevVehicle => ({
                                        ...prevVehicle,
                                        administrative: {
                                            ...prevVehicle.administrative,
                                            vat_deferral: target === 'true',
                                        },
                                    }));
                                }}
                                invalid={soldErrors && soldErrors.vat_deferral ? true : false}
                                errorMessage={soldErrors.vat_deferral}
                            />
                            <InputCustom
                                type={`date`}
                                newLabel={`Warranty Expiry Date`}
                                value={vehicle && vehicle.administrative?.warranty_expiry_date ? formatDate(vehicle.administrative.warranty_expiry_date) : ''}
                                onChange={e => setVehicle({
                                    ...vehicle,
                                    administrative: {
                                        ...vehicle.administrative,
                                        warranty_expiry_date: e.target.value,
                                    }
                                })}
                                invalid={soldErrors && soldErrors.warranty_expiry_date ? true : false}
                                errorMessage={soldErrors.warranty_expiry_date}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card>
                                <div>
                                    <h2>Settlement cost</h2>
                                    {vehicle.status === vehicleRepository?.sold
                                        && vehicle.delivered_to_us
                                        && vehicle.sold_at
                                        && <h3 className="mt-3 text-muted">{`From ${formatDate(vehicle.delivered_to_us)} To ${formatDate(vehicle.sold_at)}`}</h3>}
                                </div>
                                <div>
                                    {delay && <Table className="align-items-center" responsive>
                                        <thead className="thead-light">
                                        <tr>
                                            <th scope="col">Amount Paid</th>
                                            <th scope="col">Paid / Remained months</th>
                                            <th scope="col">Monthly cost</th>
                                            <th scope="col">Settlement cost</th>
                                            <th scope="col">Total cost</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>
                                                {settlementCost?.totalPaid}
                                            </td>
                                            <td>
                                                {`${settlementCost?.paidMonths} / ${settlementCost?.remainedMonths}`}
                                            </td>
                                            <td>
                                                {settlementCost?.monthlyCost}
                                            </td>
                                            <td>
                                                <Input
                                                    type={`number`}
                                                    value={settlementCost?.settlementCost !== null && settlementCost?.settlementCost !== undefined ? settlementCost.settlementCost : ''}
                                                    onChange={e => setSettlementCost({
                                                        ...settlementCost,
                                                        settlementCost: e.target.value,
                                                    })}
                                                />
                                            </td>
                                            <td>
                                                {settlementCost?.totalCost}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </Table>}
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <ButtonContainer reverse disabled={!updateValuationEnable} onClick={() =>{
                                setUpdateValuationEnable(false);
                                updateVehicleAdministrative(vehicle, settlementCost, () => {
                                    setUpdateValuationEnable(true);
                                })
                            }}>Save</ButtonContainer>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            <Card>
                <CardHeader>
                    <h2>Sold process</h2>
                    <Row>
                        <Col md={4} sm={12}>
                            <InputCustom
                                type={`number`}
                                newLabel={`Sold amount`}
                                value={vehicle && vehicle.administrative?.sold_amount ? vehicle.administrative.sold_amount : ''}
                                onChange={e => setAdministrativeValues(e, 'sold_amount')}
                                invalid={soldErrors && soldErrors.sold_amount ? true : false}
                                errorMessage={soldErrors.sold_amount}
                            />
                            <InputCustom
                                type={`date`}
                                newLabel={`Sold at`}
                                value={vehicle && vehicle.administrative?.sold_at ? formatDate(vehicle.administrative.sold_at) : ''}
                                onChange={e => setAdministrativeValues(e, 'sold_at')}
                                invalid={soldErrors && soldErrors.sold_at ? true : false}
                                errorMessage={soldErrors.sold_at}
                            />
                            <InputCustom
                                type={`text`}
                                newLabel={`Sold To`}
                                value={vehicle && vehicle.administrative?.sold_to ? vehicle.administrative.sold_to : ''}
                                onChange={e => setAdministrativeValues(e, 'sold_to')}
                                invalid={soldErrors && soldErrors.sold_to ? true : false}
                                errorMessage={soldErrors.sold_to}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <ButtonContainer reverse onClick={() => sold(
                                {
                                    settlement_cost: vehicle.administrative.settlementCost,
                                    sold_amount: vehicle.administrative.sold_amount,
                                    sold_at: vehicle.administrative.sold_at,
                                    sold_to: vehicle.administrative.sold_to,
                                }
                            )}>Sold</ButtonContainer>
                        </Col>
                    </Row>
                </CardHeader>
            </Card>
        </CardBody>
   )
}

export default VehicleFinancial;